import { AnyAction } from 'redux'
import { Observable } from 'rxjs'
import { filter } from 'rxjs/operators'
import { userApiSelectors } from '../../api/user'

export const filterCurrentAgencyId =
  (state$: any) =>
  <A extends AnyAction>(input$: Observable<A>): Observable<A> =>
    input$.pipe(
      filter(() => {
        return !!userApiSelectors.getCurrentAgencyId(state$.value)
      }),
    )

export const filterOwnerRole =
  (state$: any) =>
  <A extends AnyAction>(input$: Observable<A>): Observable<A> =>
    input$.pipe(
      filter(() => {
        return userApiSelectors.getUserRole(state$.value) === 'Owner'
      }),
    )

export const filterOnboardedAndOwner =
  (state$: any) =>
  <A extends AnyAction>(input$: Observable<A>): Observable<A> =>
    input$.pipe(filterCurrentAgencyId(state$), filterOwnerRole(state$))
